// Source and Channel Types for Contacts and Deals
// As per specification document: Especificação_Técnica_Campos_de_Source_e_Channel_-_DIVUS_CRM.docx

export const SOURCE_TYPES = [
  { value: 'Customer Referral', labelKey: 'sourceChannel.sources.customerReferral' },
  { value: 'External Referral', labelKey: 'sourceChannel.sources.externalReferral' },
  { value: 'Employee Referral', labelKey: 'sourceChannel.sources.employeeReferral' },
  { value: 'Personal Networking', labelKey: 'sourceChannel.sources.personalNetworking' },
  { value: 'Paid Ads', labelKey: 'sourceChannel.sources.paidAds' },
  { value: 'Organic Search', labelKey: 'sourceChannel.sources.organicSearch' },
  { value: 'Organic Social', labelKey: 'sourceChannel.sources.organicSocial' },
  { value: 'Cold Outreach', labelKey: 'sourceChannel.sources.coldOutreach' },
  { value: 'Direct', labelKey: 'sourceChannel.sources.direct' },
  { value: 'Reactivation', labelKey: 'sourceChannel.sources.reactivation' },
  { value: 'Upsell', labelKey: 'sourceChannel.sources.upsell' },
  { value: 'Partnership', labelKey: 'sourceChannel.sources.partnership' },
  { value: 'Content', labelKey: 'sourceChannel.sources.content' },
  { value: 'Event', labelKey: 'sourceChannel.sources.event' },
  { value: 'Other', labelKey: 'sourceChannel.sources.other' },
] as const;

export const CHANNEL_TYPES = [
  { value: 'Meta Ads', labelKey: 'sourceChannel.channels.metaAds' },
  { value: 'Google Ads', labelKey: 'sourceChannel.channels.googleAds' },
  { value: 'WhatsApp', labelKey: 'sourceChannel.channels.whatsApp' },
  { value: 'Website', labelKey: 'sourceChannel.channels.website' },
  { value: 'Landing Page', labelKey: 'sourceChannel.channels.landingPage' },
  { value: 'Phone Call', labelKey: 'sourceChannel.channels.phoneCall' },
  { value: 'Email', labelKey: 'sourceChannel.channels.email' },
  { value: 'Organic Social', labelKey: 'sourceChannel.channels.organicSocial' },
  { value: 'Referral Link', labelKey: 'sourceChannel.channels.referralLink' },
  { value: 'SMS', labelKey: 'sourceChannel.channels.sms' },
  { value: 'Other', labelKey: 'sourceChannel.channels.other' },
] as const;

export type SourceType = typeof SOURCE_TYPES[number]['value'];
export type ChannelType = typeof CHANNEL_TYPES[number]['value'];

// "Unselected" is only used internally for legacy records, not shown in dropdowns
export const LEGACY_SOURCE = 'Unselected';

// Helper function to check if source is locked (cannot be edited)
export const isSourceLocked = (source: string | null | undefined): boolean => {
  return source !== null && source !== undefined && source !== LEGACY_SOURCE && source !== '';
};

// Helper to map source_platform to new channel
export const mapSourcePlatformToChannel = (sourcePlatform?: string): string => {
  if (!sourcePlatform) return 'Landing Page';
  const source = sourcePlatform.toLowerCase();
  if (source.includes('facebook') || source.includes('meta') || source.includes('instagram')) {
    return 'Meta Ads';
  }
  if (source.includes('google')) {
    return 'Google Ads';
  }
  if (source.includes('whatsapp')) {
    return 'WhatsApp';
  }
  return 'Landing Page';
};

// Helper to get translated label for a source value
export const getSourceLabel = (value: string | null | undefined, t: (key: string) => string): string => {
  if (!value || value === LEGACY_SOURCE) return t('sourceChannel.sources.unselected');
  const source = SOURCE_TYPES.find(s => s.value === value);
  return source ? t(source.labelKey) : value;
};

// Helper to get translated label for a channel value
export const getChannelLabel = (value: string | null | undefined, t: (key: string) => string): string => {
  if (!value) return t('sourceChannel.channels.other');
  const channel = CHANNEL_TYPES.find(c => c.value === value);
  return channel ? t(channel.labelKey) : value;
};
